package com.taager.dukan.ui.css

import web.cssom.ClassName

internal object CssClass {
    val PreformattedText = ClassName("preformatted-text")
    val PreformattedTextSingleLine = ClassName("preformatted-text single-line")
}
